  
import React, {useState, useEffect} from "react";
import styled from "styled-components";
import firebase from "firebase/app";
import { initGA, logEvent } from '../utils/analytics'

const Layout = styled.div`
    display: flex;
    flex-wrap: wrap;
    .left {
        flex: 0.7;
        ul {
            list-style: none;
            margin: 0;     
            margin-left: -30px;
            background-color: #000;
        }
        ul li {
            color: green;
            display: inline-block;
            padding: 1rem;
            padding-right: 3rem;
            font-size: 1.4em;
            font-weight: bold;
            cursor: pointer;
            &:hover,
            &.active {
                border: 2px solid green;
            }
        }
    }
    .right{
        align-items: center;
        display: flex;
        > a {
            color: green;
            text-decoration: none;
            margin-left: 15px;
            font-size: 1.4em;
            font-weight: bold;
            :hover{
                text-decoration: underline;
            }
        }
    }
`;

const Nav = () => {
    const [ad, setAd] = useState(null)
    useEffect(() => {
        let mounted = true;
        if(mounted){
            getTopNavAd();
        }
        
        return () => { // This code runs when component is unmounted
            mounted = false;
        }
    }, []);
    const getTopNavAd = async () => {
        const db = firebase.firestore();
        const topNavAdsRef = await db
        .collection("sponsorships")
        .where("type", "==", "nav")
        .where("active", "==", true)
        .limit(1);
    
      const adsSnapshot = await topNavAdsRef.get().catch(err => {
        console.log("Error getting ad");
        console.error(err);
      });
    
      const docData = adsSnapshot.docs[0].data();
    
      setAd({
          text: docData.text,
          adWebsite: docData.website,
          image: tempImageFix(docData.image),
          companyName: docData.companyName
      });
    }


    const tempImageFix = (url) => {
        if (!url) return false;
    
        if (!url.startsWith("http")) {
        url = new URL(url, "http://35.244.241.141/").toString();
        }
    
        return `${url?.replace(
            "https://hackernoon.com/",
            "https://cdn.hackernoon.com/"
        )}`
    }

    const incrementSponsorshipDatum = () => {
        const data = {
          sponsorship: ad.owner,
          field: "clicks",
        };
    
        logEvent({
          category: "Ads",
          action: "Clicked Top Nav Ad From Terminal",
          label: `${ad.companyName} - ${ad.text}`,
        });
      };
    // const hackedAdImageFix = (ad.image);
    return (
        <>
            <Layout>
                <div className="left">
                    <ul> 
                        <li onClick={() => window.open("https://hackernoon.com", "_blank")}>
                            <img style={{marginRight: "5px"}} src="/favicon.ico" alt={`logo`} width="15"/>
                            Home
                        </li>
                        <li onClick={() => window.location = "/help"}>Help</li>
                        <li onClick={() => window.open("https://app.hackernoon.com/new", "_blank")}>Start Writing</li>
                    </ul>
                </div>
                {ad !== null && (
                    <div className="right">
                        <a href={ad.adWebsite} onClick={incrementSponsorshipDatum} target="_blank" rel="sponsored">
                            <img src={ad.image} alt={`${ad.companyName} ad`} width="65"/>
                        </a>
                        <a href={ad.adWebsite} onClick={incrementSponsorshipDatum} target="_blank" rel="sponsored">
                            {ad.text}
                        </a>
                    </div>
                )}
            </Layout>
            <hr/>
        </>
    );
};

export default Nav;